import {inlineError, tracer} from '@s-ui/decorators/lib'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetPhoneVerificationCodeUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.getCurrentUserService
   * @param {Service} deps.getPhoneVerificationCodeUserService
   * @param {EntityFactory} deps.userEntityFactory
   * @param {ErrorFactory} deps.userNotLoggedInUserErrorFactory
   */
  constructor({
    getCurrentUserService,
    getPhoneVerificationCodeUserService,
    userEntityFactory,
    userNotLoggedInUserErrorFactory
  }) {
    super()
    this._getCurrentUserService = getCurrentUserService
    this._getPhoneVerificationCodeUserService = getPhoneVerificationCodeUserService
    this._userEntityFactory = userEntityFactory
    this._userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
  }

  @tracer({metric: 'GetPhoneVerificationCodeUserUseCase#execute'})
  @inlineError
  async execute(params) {
    const currentUserEntity = await this._getCurrentUserService.execute()

    if (!currentUserEntity)
      return Promise.reject(
        this._userNotLoggedInUserErrorFactory({
          message: 'To get phone verification code the user must be logged in'
        }).toJSON()
      )

    const userEntity = this._userEntityFactory({
      email: currentUserEntity.toJSON().email,
      phone: params.phone,
      userId: currentUserEntity.getId()
    })

    const [error] = await this._getPhoneVerificationCodeUserService.execute({
      userEntity
    })

    return error ? Promise.reject(error) : Promise.resolve()
  }
}
